<payee-popup>
  <ng-template #payeePopupTitleTemplate>
    <h1 class="title top-margin-20">
      {{ "WORKFLOW_DIALOGS.DEBTOR_IND_DATA.TITLE" | translate }}
    </h1>
  </ng-template>

  <div class="help-text">
    <div>
      {{ "WORKFLOW_DIALOGS.DEBTOR_IND_DATA.DESCRIPTION" | translate }}
    </div>
    <div class="top-margin-20">
      <a
        href="https://help.payee.tech/hu/articles/6228821-nem-tudom-az-ados-lakcimet-anyja-nevet-vagy-szuletesi-adatait-mi-a-teendo"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ "WORKFLOW_DIALOGS.DEBTOR_IND_DATA.NO_DATA_INFO.LINK_TEXT" | translate }}
      </a>
    </div>
  </div>

  <form
    class="top-margin-10"
    [formGroup]="form"
  >
    <payee-form-field
      width="max"
      height="taller"
    >
      <span payee-label>
        {{ "WORKFLOW_DIALOGS.DEBTOR_IND_DATA.MOTHER_NAME.LABEL" | translate }}
      </span>
      <input
        payee-input
        formControlName="mother_name"
        [placeholder]="'WORKFLOW_DIALOGS.DEBTOR_IND_DATA.MOTHER_NAME.PLACEHOLDER' | translate"
      />
      @if (mother_name.invalid && mother_name.dirty) {
        <ng-container payee-error>
          @if (mother_name.hasError("required")) {
            <span>
              {{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}
            </span>
          }
          @if (mother_name.hasError("maxlength")) {
            <span>
              {{ "ERROR_MESSAGES.MAXLENGTH" | translate }}
            </span>
          }
        </ng-container>
      }
    </payee-form-field>

    <payee-form-field
      width="max"
      height="taller"
    >
      <span payee-label>
        {{ "WORKFLOW_DIALOGS.DEBTOR_IND_DATA.BIRTH_PLACE.LABEL" | translate }}
      </span>
      <input
        payee-input
        formControlName="birth_place"
        [placeholder]="'WORKFLOW_DIALOGS.DEBTOR_IND_DATA.BIRTH_PLACE.PLACEHOLDER' | translate"
      />
      @if (birth_place.invalid && birth_place.dirty) {
        <ng-container payee-error>
          @if (birth_place.hasError("required")) {
            <span>
              {{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}
            </span>
          }
          @if (birth_place.hasError("maxlength")) {
            <span>
              {{ "ERROR_MESSAGES.MAXLENGTH" | translate }}
            </span>
          }
        </ng-container>
      }
    </payee-form-field>

    <payee-form-field
      width="max"
      height="taller"
    >
      <span payee-label>
        {{ "WORKFLOW_DIALOGS.DEBTOR_IND_DATA.BIRTH_DATE.LABEL" | translate }}
      </span>
      <payee-datepicker
        formControlName="birth_date"
        [max]="maxBirthDate"
        [placeholder]="'WORKFLOW_DIALOGS.DEBTOR_IND_DATA.BIRTH_DATE.PLACEHOLDER' | translate"
      ></payee-datepicker>
      @if (birth_date.invalid && birth_date.dirty) {
        <ng-container payee-error>
          @if (birth_date.hasError("required")) {
            <span>
              {{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}
            </span>
          }
          @if (birth_date.hasError("maxdate")) {
            <span>
              {{ "WORKFLOW_DIALOGS.DEBTOR_IND_DATA.BIRTH_DATE.MAX_ERROR" | translate }}
            </span>
          }
        </ng-container>
      }
    </payee-form-field>
  </form>

  <ng-template #payeePopupSubmitTemplate>
    <button
      payee-button
      width="max"
      [disabled]="loading || dialogDataLoading"
      [loading]="loading"
      (click)="submit()"
    >
      <div class="flex vcenter hcenter">
        <span>{{ "WORKFLOW_DIALOGS.DEBTOR_IND_DATA.SUBMIT" | translate }}</span>
        <payee-icon
          name="arrow-right-white"
          height="10px"
        ></payee-icon>
      </div>
    </button>
  </ng-template>

  <ng-template #payeePopupCancelTemplate>
    <button
      payee-button
      width="max"
      mat-dialog-close
      color="white"
      [isBorderButton]="true"
    >
      <div class="flex vcenter hcenter">
        <span>{{ "WORKFLOW_DIALOGS.DEBTOR_IND_DATA.CANCEL" | translate }}</span>
        <payee-icon
          name="arrow-right-grey"
          height="10px"
        ></payee-icon>
      </div>
    </button>
  </ng-template>
</payee-popup>
